export default {"src":"/_next/static/media/noun-funds-immediately.5916e077.svg","height":45,"width":40};